<template lang="pug">
  .information-edit
    .title {{ user.is_completed === 0 ? $t('完善信息') : $t('编辑信息') }}
    tabs(
      :tabs="TABS.map(t => t.name)"
      :index="tabIndex"
      @change="changeTab"
    )
    router-view
</template>

<script>
import Tabs from '@/components/Tabs'

const TABS = [
  {
    name: '一般信息',
    url: '/information/edit/general'
  },
  {
    name: '客户案例',
    url: '/information/edit/capability'
  }
]
export default {
  components: {
    Tabs
  },
  data () {
    return {
      TABS,
      tabIndex: null
    }
  },
  mounted () {
    this.tabIndex = this.TABS.findIndex(t => t.url === this.$route.path)
  },
  methods: {
    changeTab (index) {
      this.tabIndex = index
      this.$router.push(this.TABS[index].url)
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  }
}
</script>

<style lang="stylus">
.information-edit
  .campaign-tab
    margin 30px 0
    .el-tabs__item.is-top
      font-size 16px !important

.title
  font-size 18px
  color #4a4a4a

.process-bar
  position relative
  margin 10px -20px 20px
  background #f6f6f6
  padding 10px 0
  display flex
  justify-content center

.step--1
.step--2
  color #d4d8df
  &.active
    color #00a0e5
  i
    margin 0 3px

.step--1
  margin-right 50px

.icon-tri_down
  font-size 30px
  color #f6f6f6
  position absolute
  top 29px
  left 51%
</style>
